module.exports = __webpack_public_path__ + "static/img/stamp_10.faefde6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_10.jpg
// module id = 1Aqb
// module chunks = 7